import './styles/header.css'
import { useEffect } from 'preact/hooks';
import { handleMenuToggle } from './scripts/headerMenu';
import { initializeThemeSwitch } from './scripts/themeSwitch';
import Profile from './components/ProfileDropdown';

const Header = () => {
  useEffect(() => {
    handleMenuToggle();
    initializeThemeSwitch();
  }, []);
  
  return (
  <header className="header">
    <div className="header_body">
    <div className="header_burger">
        <span></span>
    </div>
      <b><a className="main" href="/main">Канал МТВ</a></b>
      <b><a className="main_small" href="/main">МТВ</a></b>
      <nav className="header_menu">
        <ul className="header_list">
          <li><h3><a className="header_link" href="/cringe-lounge">Cringe lounge</a></h3></li>
          <li><h3><a className="header_link" href="/new-site">Новый сайт: FAQ</a></h3></li>
        </ul>
      </nav>
      <div className='header_actions'>
        <div className="profile">
          <div className='profile-btn'>
            <button>
              <svg id='profileIcon' xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#FFFFFF"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5zm10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z"/><path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"/></g></g></svg>
            </button>
            <span className='tooltiptext'>Профиль</span>
          </div>
          <Profile />
        </div>
        <div className="theme-switch">
          <button id="theme-toggle-btn">
            <svg id="moonSun" xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px"><rect fill="none" height="24" width="24"/><path d="M9.37,5.51C9.19,6.15,9.1,6.82,9.1,7.5c0,4.08,3.32,7.4,7.4,7.4c0.68,0,1.35-0.09,1.99-0.27C17.45,17.19,14.93,19,12,19c-3.86,0-7-3.14-7-7C5,9.07,6.81,6.55,9.37,5.51z M12,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9c0-0.46-0.04-0.92-0.1-1.36c-0.98,1.37-2.58,2.26-4.4,2.26c-2.98,0-5.4-2.42-5.4-5.4c0-1.81,0.89-3.42,2.26-4.4C12.92,3.04,12.46,3,12,3L12,3z"/></svg>
          </button>
          <span className="tooltiptext">Сменить тему сайта</span>
        </div>
      </div>
    </div>
  </header>
);
};

export default Header;
